const apiBase = 'https://registrodeenvios-dev.olvaexpress.pe';
const domainBase = 'https://dev-registro-envios-mat-design.olvacourier.com';
export const environment = {
    production: false,
    environment: 'development',
    shippingRecords: {
        api: apiBase,
        public: {
            config: {
                grant_type: 'client_credentials',
                client_id: 'app_web_id',
                client_secret: '123456'
            }
        }
    },
    recaptcha: {
        siteKey: '6Lfa4NosAAAAADgRBeI_fElqt1l4bmxfDCLX2Typ'
    },
    home: {
        backUrl: 'https://www.olvacourier.com/',
        trackingUrl: 'https://tracking.olvacourier.com/',
        packagingRequest: {
            url: 'https://registrodeenvios-empaques.olvacourier.com/compra-empaques',
            fields: {
                txt_tipo_envio: 'empaques',
                _token: 'kRanX67YAJ3elAgVIn1jFgtOFLSFMIiJcyWzxYDk',
                radioTipoEnvio: 'rbtn_caja',
                terminos_hid: 'true',
                terminos: 'on'
            }
        },
        importantInformation: {
            restrictedGoodsUrl: 'https://www.olvacourier.com/noticias/mercancia-prohibida/37',
            pickupUrl: 'https://atc.olvaexpress.pe/user/login',
            deliveryTimesUrl: 'https://www.olvacourier.com/tiempos-de-entrega',
            storesLimaUrl: 'https://www.olvacourier.com/noticias/tiendas-lima/44/',
            storesProvincesUrl: 'https://www.olvacourier.com/noticias/tiendas-provincias/42'
        }
    },
    satisfactionSurveyUrl: 'https://es.surveymonkey.com/r/WBMXFZH',
    paymentGateway: {
        niubiz: {
            assets: {
                scriptCheckout: 'https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true'
            }
        },
        assets: {
            olvaLogo: 'https://res.cloudinary.com/marmotahosting/image/upload/v1781124124/Olva/payment-modal-olva-logo.svg'
            // olvaLogo: 'https://res.cloudinary.com/marmotahosting/image/upload/v1772646298/olva_logo_mp_ituzls.png'
        },
        callback: domainBase + '/shipment-record/finish',
        callbackError: domainBase + '/shipment-record/payment/failed'
    },
    thirdPartyScripts: {
        googleTagManager: {
            enabled: false,
            containerId: 'GTM-WGMWXS5S'
        },
        googleAnalytics: {
            // El Google tag de GA4 (G-EP1BYS5XMB) se carga desde GTM.
            // No reinyectar gtag.js aquí; usar un measurement ID (G-XXXX) solo si se requiere carga directa.
            enabled: false,
            trackingId: ''
        },
        facebookPixel: {
            enabled: false,
            pixelId: ''
        },
        microsoftClarity: {
            enabled: true,
            projectId: 'xyoyejs7vo'
        }
    },
    cookies: {
        policyUrl: 'https://www.olvacourier.com/conoce-nuestras-politicas-de-cookies/'
    }
};
